import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const LineHeight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 6C8.22386 6 8 6.22386 8 6.5C8 6.77614 8.22386 7 8.5 7H21C21.2761 7 21.5 6.77614 21.5 6.5C21.5 6.22386 21.2761 6 21 6H8.5ZM8 12C8 11.7239 8.22386 11.5 8.5 11.5L21 11.5C21.2761 11.5 21.5 11.7239 21.5 12C21.5 12.2761 21.2761 12.5 21 12.5L8.5 12.5C8.22386 12.5 8 12.2761 8 12ZM8 17.5C8 17.2239 8.22386 17 8.5 17H21C21.2761 17 21.5 17.2239 21.5 17.5C21.5 17.7761 21.2761 18 21 18H8.5C8.22386 18 8 17.7761 8 17.5ZM7.35355 13.6464C7.54882 13.8417 7.54882 14.1583 7.35355 14.3536L5.35355 16.3536C5.15829 16.5488 4.84171 16.5488 4.64645 16.3536L2.64645 14.3536C2.45118 14.1583 2.45118 13.8417 2.64645 13.6464C2.84171 13.4512 3.15829 13.4512 3.35355 13.6464L5 15.2929L6.64645 13.6464C6.84171 13.4512 7.15829 13.4512 7.35355 13.6464ZM2.64645 9.64645C2.45118 9.84171 2.45118 10.1583 2.64645 10.3536C2.84171 10.5488 3.15829 10.5488 3.35355 10.3536L5 8.70711L6.64645 10.3536C6.84171 10.5488 7.15829 10.5488 7.35355 10.3536C7.54882 10.1583 7.54882 9.84171 7.35355 9.64645L5.35355 7.64645C5.15829 7.45118 4.84171 7.45118 4.64645 7.64645L2.64645 9.64645Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default LineHeight
